import { countLabel } from "../benchmarkApi/reportData"
import { methodologyContent } from "./methodologyContent"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

export default function MethodologySection({ statsStatus, totalCompanies }) {
  const count = countLabel(statsStatus, totalCompanies)

  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col gap-8">
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">
          {methodologyContent.eyebrow}
        </p>
        <h2 className={headingClass}>{methodologyContent.title}</h2>
      </div>
      <ul className="m-0 flex max-w-[68ch] list-disc flex-col gap-3 pl-5 text-[16px] font-normal leading-6 text-[#4D4D4D]">
        {methodologyContent.points.map((point) => (
          <li key={point.label}>
            <span className="font-bold text-[#171717]">{point.label}</span>{" "}
            {point.body.replaceAll("{count}", count)}
          </li>
        ))}
      </ul>
    </section>
  )
}
